import { Autocomplete, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";

import { OutletProductSelect } from "@/features/products";

import { CustomInputField } from "../custom-input-field";

const renderVariantAttribute = ({
  attribute,
  attributeValues,
  index,
  value,
  onChange,
}) => {
  if (!attribute) return null;

  return (
    <Grid size={{ xs: 6, sm: 3, md: 6, lg: 3 }}>
      <Autocomplete
        fullWidth
        value={value}
        onChange={(_, newValue) => onChange(index, newValue)}
        disableClearable
        options={attributeValues}
        renderInput={(params) => (
          <CustomInputField
            {...params}
            label={attribute?.name}
            InputProps={{
              ...params.slotProps.input,
              placeholder: "Pilih",
            }}
          />
        )}
      />
    </Grid>
  );
};

export const ProductVariantPicker = ({
  picker,
  outletId,
  productSelectLabel = "Produk",
}) => {
  const {
    product,
    setProduct,
    variantValues,
    setVariantValue,
    attributeMeta,
    loading,
  } = picker;

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <OutletProductSelect
          outletId={outletId}
          value={product}
          onChange={setProduct}
          TextFieldProps={{ label: productSelectLabel }}
        />
      </Grid>
      {(loading.attrs || !product) && (
        <Grid size={{ xs: 12 }}>
          <Typography variant="body2" sx={{
            color: "text.disabled"
          }}>
            {loading.attrs
              ? "Loading..."
              : "-Pilih Produk untuk memunculkan Atribut Variant-"}
          </Typography>
        </Grid>
      )}
      {renderVariantAttribute({
        attribute: attributeMeta?.variantAttribute1,
        attributeValues: attributeMeta?.variantAttribute1Values,
        index: 0,
        value: variantValues.variantAttribute1Value,
        onChange: setVariantValue,
      })}
      {renderVariantAttribute({
        attribute: attributeMeta?.variantAttribute2,
        attributeValues: attributeMeta?.variantAttribute2Values,
        index: 1,
        value: variantValues.variantAttribute2Value,
        onChange: setVariantValue,
      })}
      {renderVariantAttribute({
        attribute: attributeMeta?.variantAttribute3,
        attributeValues: attributeMeta?.variantAttribute3Values,
        index: 2,
        value: variantValues.variantAttribute3Value,
        onChange: setVariantValue,
      })}
      {renderVariantAttribute({
        attribute: attributeMeta?.variantAttribute4,
        attributeValues: attributeMeta?.variantAttribute4Values,
        index: 3,
        value: variantValues.variantAttribute4Value,
        onChange: setVariantValue,
      })}
    </Grid>
  );
};

ProductVariantPicker.propTypes = {
  picker: PropTypes.object.isRequired,
  outletId: PropTypes.string,
  productSelectLabel: PropTypes.string,
};
